const KEY_ARROW_LEFT = 37;
const KEY_ARROW_UP = 38;
const KEY_ARROW_RIGHT = 39;
const KEY_ARROW_DOWN = 40;
const KEY_ENTER = 13;
const KEY_SPACE = 32;

export default function useHandleSectionNavigation({
  state,
  setTabIndex,
  onKeyDown,
  setIsShowPanels,
  isShowPanels,
  index,
  totalItems,
  setSelectTabPanelTabIndex
}) {
  const handleKeyDown = (e) => {
    if (e.keyCode === KEY_ENTER) {
      setSelectTabPanelTabIndex(-1);
      onKeyDown(index);
    } else if (e.keyCode === KEY_SPACE) {
      e.preventDefault();
      setSelectTabPanelTabIndex(-1);
      if (!isShowPanels) {
        setIsShowPanels(true);
        state?.setSelectedKey(`"${index}`);
        setTabIndex(parseInt(index));
      }
    } else if (e.keyCode === KEY_ARROW_RIGHT) {
      setSelectTabPanelTabIndex(-1);
      if (!isShowPanels) {
        setIsShowPanels(true);
      }
      const nextKey = state.selectedItem.nextKey;
      if (nextKey !== undefined) {
        state?.setSelectedKey(nextKey);
        setTabIndex(parseInt(nextKey));
      } else {
        state?.setSelectedKey(`0`);
        setTabIndex(0);
      }
    } else if (e.keyCode === KEY_ARROW_LEFT) {
      setSelectTabPanelTabIndex(-1);
      if (!isShowPanels) {
        setIsShowPanels(true);
      }
      const prevKey = state.selectedItem.prevKey;
      if (prevKey !== undefined) {
        state?.setSelectedKey(prevKey);
        setTabIndex(parseInt(prevKey));
      } else {
        state?.setSelectedKey(`${totalItems - 1}`);
        setTabIndex(totalItems - 1);
      }
    } else if (e.keyCode === KEY_ARROW_DOWN) {
      e.preventDefault();
      setSelectTabPanelTabIndex(-1);
      const nextKey = state.selectedItem.nextKey;
      if (nextKey !== undefined) {
        state?.selectionManager?.state?.setFocusedKey(nextKey);
        state?.setSelectedKey(nextKey);
        setTabIndex(parseInt(nextKey));
      } else {
        state?.selectionManager?.state?.setFocusedKey(`0`);
        state?.setSelectedKey(`0`);
        setTabIndex(0);
      }
      if (!isShowPanels) {
        setIsShowPanels(true);
      }
    } else if (e.keyCode === KEY_ARROW_UP) {
      e.preventDefault();
      setSelectTabPanelTabIndex(-1);
      const prevKey = state.selectedItem.prevKey;
      if (prevKey !== undefined) {
        state?.selectionManager?.state?.setFocusedKey(prevKey);
        state?.setSelectedKey(prevKey);
        setTabIndex(parseInt(prevKey));
      } else {
        state?.selectionManager?.state?.setFocusedKey(`${totalItems - 1}`);
        state?.setSelectedKey(`${totalItems - 1}`);
        setTabIndex(totalItems - 1);
      }
      if (!isShowPanels) {
        setIsShowPanels(true);
      }
    }
  };

  return handleKeyDown;
}
